import { Component, OnInit } from "@angular/core";
import { LoggerService } from "../../../../shared/logger.service";
import { AuthService } from "@app/services/auth.service";
import { GoalsService } from "@app/features/goals/services/goals.service";
import { TasksService } from "@app/features/tasks/services/tasks.service";
import { RoutinesService } from "@app/features/routines/services/routines.service";

@Component({
  selector: "app-user-home",
  templateUrl: "./user-home.component.html",
  styleUrls: ["./user-home.component.scss"],
})
export class UserHomeComponent implements OnInit {
  user: any = {};

  constructor(
    private logger: LoggerService,
    private authService: AuthService,
    private goalsService: GoalsService,
    private tasksService: TasksService,
    private routinesService: RoutinesService,
  ) {}

  kpis = {
    metasConcluidas: 3,
    metasPendentes: 2,
    progresso: 64,
    docsLidos: 2,
    totalDocs: 3,
  };

  metas: any[] = [];
  tarefas: any[] = [];
  rotinas: any[] = [];

  documentos = [
    { nome: "Política de Segurança da Informação", url: "#" },
    { nome: "Manual de Boas Práticas", url: "#" },
  ];

  abrirDocumento(doc: any) {
    this.logger.debug("Abrindo documento:", doc);
    // Aqui você abriria um modal de visualização
  }

  ngOnInit(): void {
    this.loadUser();
  }

  private loadUser(): void {
    const user = history.state.user;

    if (user) {
      this.user = user;
      this.loadGoals(user.id);
      this.loadTasks(user.id);
      this.loadRoutines();
      return;
    }

    this.authService.getCurrentUser().subscribe({
      next: (userData) => {
        this.user = userData;
        this.loadGoals(userData.id);
        this.loadTasks(userData.id);
        this.loadRoutines();
      },
      error: (error) => {
        this.logger.error("Erro ao obter usuário atual:", error);
      },
    });
  }

  private loadGoals(userId: string): void {
    this.goalsService.findAllByPersonId(userId).subscribe({
      next: (goals) => {
        this.metas = goals;
      },
      error: (error) => {
        this.logger.error("Erro ao obter metas do usuário:", error);
      },
    });
  }

  private loadTasks(userId: string): void {
    this.tasksService.findAllByPersonId(userId).subscribe({
      next: (tasks) => {
        this.tarefas = tasks;
      },
      error: (error) => {
        this.logger.error("Erro ao obter tarefas do usuário:", error);
      },
    });
  }

  private loadRoutines(): void {
    this.routinesService.findAllByMe().subscribe({
      next: (routines) => {
        this.rotinas = routines;
      },
      error: (error) => {
        this.logger.error("Erro ao obter rotinas:", error);
      },
    });
  }
}
